

import clsx from "clsx";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import styles from "./auth.module.scss";
import FormInput from "./formInput";

export default function Component({ setForm }: { setForm: (form: string) => void }) {
    const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm<{ email: string }>()

    const onSubmit = handleSubmit(async data => {
        return fetch("/api/auth/password/request", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
        })
            .then(r => r.json())
            .then(r => {
                if (!r.resp) throw new Error(r.msg)

                toast.success("Σύνδεσμος επαναφοράς κωδικού αποστάλθηκε στο email σας.")
                setForm("")
            }).catch(e => toast.error(e.message))
    })

    return (
        <div className={styles.signIn}>
            Συμπληρώστε το email σας. Θα σας αποσταλεί σύνδεσμος επαναφοράς του κωδικού σας.
            <form onSubmit={onSubmit}>
                <FormInput
                    error={errors.email?.message}
                    type="email"
                    className={clsx(styles.inputContainerCustomStyle, styles.forgotPasswordEmail)}
                    placeholder="Email"
                    {...register("email", { required: "Αυτό το πεδίο είναι υποχρεωτικό" })}
                />
                <button className="cmnBtn" disabled={isSubmitting}>Συνέχεια</button>
            </form>
        </div>
    )
}